import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  'title': {
    id: 'license.contactPerson.title',
    description: 'Title for license TOS & contact person dialog',
    defaultMessage: 'Terms of service and contact person',
  },
  'info': {
    id: 'license.contactPerson.info',
    description: 'Info for license TOS and contact person dialog',
    defaultMessage: 'Choose or add a company contact person for this license contract. The chosen person will be marked as the acceptor of the terms of service.',
  },
  'confirmAddButtonLabel': {
    id: 'license.contactPerson.button.add.confirm.label',
    description: 'Label for license contact person add new confirm button',
    defaultMessage: 'Save',
  },
  'cancelAddButtonLabel': {
    id: 'license.contactPerson.button.add.cancel.label',
    description: 'Label for license contact person add new cancel button',
    defaultMessage: 'Cancel add',
  },
  'confirmUpdateButtonLabel': {
    id: 'license.contactPerson.button.update.confirm.label',
    description: 'Label for license contact person update info confirm button',
    defaultMessage: 'Save',
  },
  'cancelUpdateButtonLabel': {
    id: 'license.contactPerson.button.update.cancel.label',
    description: 'Label for license contact person update info cancel button',
    defaultMessage: 'Cancel edit',
  },
  'updateButtonLabel': {
    id: 'license.contactPerson.button.update.label',
    description: 'Label for license contact person update info',
    defaultMessage: 'Edit',
  },
  'continueButtonLabel': {
    id: 'license.contactPerson.button.continue.label',
    description: 'Label for license contact person continue button',
    defaultMessage: 'Continue',
  },
  'backButtonLabel': {
    id: 'license.contactPerson.button.back.label',
    description: 'Label for license contact person back button',
    defaultMessage: 'Back',
  },
});
